import { render, staticRenderFns } from "./IndexComplainToDo.vue?vue&type=template&id=3b1e38f3&scoped=true"
import script from "./IndexComplainToDo.vue?vue&type=script&lang=js"
export * from "./IndexComplainToDo.vue?vue&type=script&lang=js"
import style0 from "./IndexComplainToDo.vue?vue&type=style&index=0&id=3b1e38f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e38f3",
  null
  
)

export default component.exports